import Arrow, { ArrowProps } from './Arrow';

export default Arrow;
export type { ArrowProps };
